const sizeConfigs = {
  sidebar: {
    width: "15rem",
    xsWidth: "0rem"
  }
};



export default sizeConfigs;
